module.exports = __webpack_public_path__ + "img/zoom4.17ffa20b.png";